import { createFileRoute, Link } from '@tanstack/react-router';
import { Card, CardContent, CardHeader, CardTitle } from '@ludolio/shared-ui';
import { Clock } from 'lucide-react';

export const Route = createFileRoute('/_authenticated/legal')({
  component: LegalPage,
});

function LegalPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-foreground">Legal</h1>
        <p className="text-muted-foreground mt-1">
          Terms, policies, and compliance resources for developers.
        </p>
      </div>

      <Card>
        <CardHeader className="flex flex-row items-center gap-3">
          <Clock className="h-6 w-6 text-[hsl(var(--color-primary))]" />
          <CardTitle>Coming Soon</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4 text-sm text-muted-foreground">
          <p>
            Our legal portal is being prepared. It will include the Developer Distribution Agreement,
            content guidelines, and data-processing addenda. If you have an urgent legal question,
            please reach out via the <Link to="/support" className="underline text-foreground">Support</Link> page.
          </p> 
        </CardContent>
      </Card>
    </div>
  );
}
